export default function Navigation() {
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    document.querySelector(sectionId)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };

  return (
    <nav>
      <div className="nav-container">
        <a href="#hero" onClick={(e) => scrollToSection(e, '#hero')} className="nav-logo">S.H.</a>
        <div className="nav-links">
          <a href="#work" onClick={(e) => scrollToSection(e, '#work')}>Work</a>
          <a href="#background" onClick={(e) => scrollToSection(e, '#background')}>Background</a>
          <a href="#connect" onClick={(e) => scrollToSection(e, '#connect')}>Connect</a>
        </div>
      </div>
    </nav>
  );
}
